import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Table, Tabs, Tag, Tooltip, message } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../utils/eventEmitter';
import { Badge } from 'flowbite-react';
import dayjs from 'dayjs';
import useAnalyticDistributionModelAPI from '../apis/analyticDistributionModelAPI';
import { MdDelete } from 'react-icons/md';
import { RiDeleteBinLine } from "react-icons/ri";
import arrayToTree from '../utils/arrayToTree';




const AnalyticDistributionModelChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const { distributionModel, analytics } = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const { save } = useAnalyticDistributionModelAPI();
  const [selectedAnalytics, setSelectedAnalytics] = useState(distributionModel.analytics ? distributionModel.analytics : []);

  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['analytics'] = selectedAnalytics;
    save(data, success);
    console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    // update(analytic.seo, data, success);
    // console.log(data)
  }

  const analyticTree = arrayToTree(analytics);
  

  useEffect(() => {
    EventEmitter.subscribe('analytic_model_response', data => {
      // console.log('response: ', data);
      // let date = new Date(data).toISOString();
      // let date_ = date.split('T');
      // date_[1] = date_[1].slice(0, -5);
      // date_.join(' ');
      navigate('/accounting/analytic-distribution-models/'+data);
    });
    
    return () => EventEmitter.unsubscribe('analytic_model_response');
  },[]);

  const addLine = (anId) => {
    let selectedAnalytics_ = [...selectedAnalytics];
    let obj = {key: selectedAnalytics.length +1, id: '', distributePercent: 100};
    let findArr = selectedAnalytics_.findIndex((_, id) => id === anId);
    if (findArr === -1) {
      let arr = [obj];
      selectedAnalytics_.push(arr);
    }else {
      let arr = selectedAnalytics_[anId];
      // if (arr.length === 1) {
      //   arr.forEach(distributeAnalytic => {
      //     if (distributeAnalytic.distributePercent === 100){
      //       obj.distributePercent = 100 - distributeAnalytic.distributePercent;
      //     }
      //   });
      // }else if (arr.length > 2) {
      //   arr.forEach(distributeAnalytic => {
      //     distributeAnalytic.distributePercent /= arr.length
      //   });
      //   obj.distributePercent /= arr.length;
      // }
      arr.push(obj);
      selectedAnalytics_[anId] = arr;
    }
    console.log(selectedAnalytics_, anId)
    setSelectedAnalytics(selectedAnalytics_);
  }

  const onChangeSelect = (v, opt, anId, id) => {
    let selectedAnalytics_ = [...selectedAnalytics];
    selectedAnalytics_[anId][id].id = v;
    setSelectedAnalytics(selectedAnalytics_);
  }

  const onDeleteSelected = (anId, id) => {
    let selectedAnalytics_ = [...selectedAnalytics];
    selectedAnalytics_[anId].splice(id, 1);
    setSelectedAnalytics(selectedAnalytics_);
  }

  const onDeselect = (tag) => {
    let selectedAnalytics_ = [...selectedAnalytics];
    let selectedArr = selectedAnalytics_.map(arr => arr.filter(item => item.id !== tag.id));
    setSelectedAnalytics(selectedArr);
    // console.log(selectedIndex)
  }

  const onChangeDistributePercent = (value, anId, id) => {
    let selectedAnalytics_ = [...selectedAnalytics];
    selectedAnalytics_[anId][id].distributePercent = value;
    setSelectedAnalytics(selectedAnalytics_);
  }
  // console.log(selectedAnalytics.flatMap(arr => arr.map(item => item.id)))
  // console.log(distributionModel)
  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/accounting/analytic-distribution-models'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Analytic Distribution Models</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ distributionModel.createdAt ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {distributionModel.createdAt && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3 shadow'>
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 9}}
          initialValues={{analytics: selectedAnalytics.map(item => item.id)}}
          variant='borderless'
        >
          <Badge className="text-slate-500 text-md bg-transparent	border-b-2">Simulatneous Conditions To Met</Badge>
          <Row>
            <Col md={{span: 10}}>
              <Form.Item label='Partner' name={'partner'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Partner Category' name={'partner_category'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Account Prefix' name={'account_prefix'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Product' name={'product'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={[]} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' style={{width: '200px'}}/>
              </Form.Item>
              <Form.Item label='Product Category' name={'product_category'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={[]} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' style={{width: '200px'}}/>
              </Form.Item>
            </Col>
          </Row>
          <Badge className="text-slate-500 text-md bg-transparent	border-b-2">Analytic Distribution To Apply</Badge>
          <Form.Item labelCol={{md: { span: 3}}} label='Analytics' className='font-semibold text-gray-800 mb-2 column' required>
            <Select 
              mode='tags'
              popupMatchSelectWidth = {300}
              value={selectedAnalytics.flatMap(arr => arr.map(item => item.id))}
              // onDeselect={onDeselect}
              options={analytics.map(account => ({value: account._id, label: account.name}))}
              className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' 
              popupClassName='custom-popupmenu'
              tagRender={props=> {
                const arr = selectedAnalytics.flatMap((selected, id) => selected.map(obj => obj));
                const item = arr.find(obj => obj.id === props.value);
                return (
                  <Tag closable onClose={()=>onDeselect(item)}>{props.label} {item.distributePercent}%</Tag>
                )
              }}
              dropdownRender={menu=> (
                <div style={{width: '100%'}}>
                  <h6 className='bg-gray-300 p-1 border-b-2'>Analytic</h6>
                  <div>
                    {analyticTree.map((analytic, anId) =>
                      <div key={analytic.plan}>
                        <p className='m-0 border-b-2 p-1'>{analytic.plan}</p>
                          {selectedAnalytics[anId] !== undefined &&
                            selectedAnalytics[anId].map((selected, id) => {
                            return (
                              <div className='flex justify-between items-center'>
                                <Select options={analytic.children.map(account => ({value: account._id, label: account.name}))} value={selected.id} onChange={(v, opt)=>onChangeSelect(v, opt, anId, id)} style={{width: '90%'}}/>
                                <div className='flex items-center w-1/2'>
                                  <InputNumber defaultValue={selected.distributePercent} onChange={value => onChangeDistributePercent(value, anId, id)} addonAfter={<span>%</span>} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal p-1'  />
                                  <RiDeleteBinLine size={'1.5rem'} className='hover:cursor-pointer hover:text-red-900' onClick={()=>onDeleteSelected(anId, id)} />
                                </div>
                              </div>
                            )
                          }
                        )}
                        <Button size='small' className='border-0 text-gray-500' onClick={()=>addLine(anId)}>Add Line</Button>
                      </div>
                    )}
                  </div>
                </div>
              )} 
            />
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}
export default AnalyticDistributionModelChanges;